import React from 'react';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { PromotionalBannerDescription } from './PromotionalBannerDescription';
import { BannerImageStyled } from './styled';
export function PromotionalBanner(props) {
    const { title, subtitle, link, description, image } = props;
    const { isInfiniteDesktopView } = useWindowSize();
    return (React.createElement(FlexWrapper, { position: "relative", isFullWidth: true, flexDirection: isInfiniteDesktopView ? 'row' : 'column', justifyContent: isInfiniteDesktopView ? 'flex-end' : 'flex-start', alignItems: isInfiniteDesktopView ? 'flex-start' : 'center' },
        React.createElement(BannerImageStyled, { ...image }),
        React.createElement(PromotionalBannerDescription, { title: title, subtitle: subtitle, link: link, description: description })));
}
